import { render, staticRenderFns } from "./form-create.vue?vue&type=template&id=da6b70e2&scoped=true"
import script from "./form-create.vue?vue&type=script&lang=js"
export * from "./form-create.vue?vue&type=script&lang=js"
import style0 from "./form-create.vue?vue&type=style&index=0&id=da6b70e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b70e2",
  null
  
)

export default component.exports